export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6472.3ae63650.jpg";